export default "__VITE_PUBLIC_ASSET__e1068e6c__"